import { Path } from "app/path";
import { selectActiveEmployees } from "app/redux/employeesSlice";
import { archiveSale, selectSales, updateSale, getSale } from "app/redux/salesSlice";
import { useQuery } from "app/utils/useQuery";
import { find } from "lodash";
import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export const useOpenSaleScreen = ({
  onCloseDrawer,
}: {
  onCloseDrawer: () => void;
}) => {
  const dispatch = useDispatch();
  const query = useQuery();
  const navigate = useNavigate();
  const saleIdParam = query.get("saleId");
  const screenParam = query.get("screen");
  const { sales } = useSelector(selectSales);
  // const sale = find(sales, (sale: any) => sale.id === Number(saleIdParam));
  const [sale, setSale] = useState<any>();
  const employees = useSelector(selectActiveEmployees);
  const employee = employees[0];
  const [isLoading, setIsLoading] = useState(false);

  const onArchiveSale = async () => {
    try {
      await dispatch(archiveSale(sale.id) as any).unwrap();
      query.delete("saleId");
      query.delete("dualPricingPaymentMethod");
      query.delete("screen");
      query.delete("status");
      toast.success(`Sale ${sale.id} archived successfully`);
      onCloseDrawer();
      navigate(Path.SALES, { replace: true });
    } catch (error) {
      console.log(error);
      toast.error(`Unable to archive sale ${sale.id}`);
    }
  };

  useEffect(() => {
    if (saleIdParam) {
      const selectedSale = find(
        sales,
        (sale: any) => sale.id === Number(saleIdParam)
      ) as any;
      if (selectedSale) {
        setSale(selectedSale);
      } else {
        setIsLoading(true);
        dispatch(getSale({ id: Number(saleIdParam) }) as any)
          .unwrap()
          .then((fetchedSale: any) => {
            setSale(fetchedSale);
          })
          .catch((err: any) => {
            console.error("Failed to fetch sale details:", err);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    }
  }, [sales, saleIdParam, dispatch]);

  return {
    employee,
    isLoading,
    sale,
    screenParam,
    onArchiveSale,
  };
};
